import type { LangCode } from '@/services/schemas'

interface PromotionData {
  id: number
  discountinpercent: string
  active: number
  startingDatetime: string
  endingDatetime: string
  labelHeadline: string
  labelHeadline2: string
  labelHeadline3: string
  labelBanner1: string
  labelSubtotal: string
  labelPDFSavingsLine: string
  imagesBackgroundImageS3Path: string
  imagesPromoImageS3Path: string
}

interface PromotionResponse {
  infoMessage: string
  promotionAvailable: boolean
  promotionAvailableCountry: string
  promotionAvailableLanguage: string
  promotionData: PromotionData | Record<string, never>
}

export async function checkPromotion(
  countryCode: string,
  language: LangCode
): Promise<PromotionResponse | null> {
  try {
    const response = await fetch(
      `${import.meta.env.VITE_API_URL}mycontroller/check-promotion/json`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          isocode: countryCode,
          lang: language,
        }),
      }
    )

    if (!response.ok) {
      throw new Error(`HTTP Error: ${response.status}`)
    }

    const data: PromotionResponse = await response.json()

    if (data.promotionAvailable) {
      console.log('🎉 Active Promotion Found:', data.promotionData)
      console.log(`Discount: ${(data.promotionData as PromotionData).discountinpercent}%`)
    } else {
      console.log('ℹ️ No active promotion available')
    }

    return data
  } catch (error) {
    console.error('Promotion API Error:', error)
    return null
  }
}

export type { PromotionData, PromotionResponse }
